module.exports = __webpack_public_path__ + "static/img/animales_01.9f818ab5.jpg";